/**
 * Feature gate for the admin AI assistant widget (docs/ai/14). The brand.ts idiom: a per-environment
 * RUNTIME value from `window.__ADMIN_V2_CONFIG__` (written by the deploy step's config.js) wins;
 * the build-time `VITE_ADMIN_AI_ASSISTANT_ENABLED` env is the local-dev/preview fallback.
 * Off/absent = byte-inert: app-shell never mounts (or lazy-loads) the widget chunk.
 */
export const isAdminAssistantEnabled = (): boolean => {
	// The client.ts:134 access pattern — `globalThis.X` only carries `var` declarations, not Window
	// interface members, so the runtime config is read through a structural cast.
	const runtime = (globalThis as { __ADMIN_V2_CONFIG__?: { aiAssistantEnabled?: boolean | string } }).__ADMIN_V2_CONFIG__
		?.aiAssistantEnabled;
	if (runtime !== undefined) return runtime === true || runtime === 'true';
	return import.meta.env.VITE_ADMIN_AI_ASSISTANT_ENABLED === 'true';
};
